import Btn from '../components/Btn';
import Tx from '../components/Tx';
import {useState} from 'react';
import ClientDialog from './dialogs/ClientDialog';
import InstallerClientCard from '../components/InstallerClientCard';
import StoresColumn from '../components/StoresColumn';

export default function StoresClients(props) {
    const [open_client_dialog, s_open_client_dialog] = useState(false);
    const [new_client, s_new_client] = useState(false);
    const [edit_item, s_edit_item] = useState({});


    return (
        <StoresColumn color="#fdd54620">
            {
                props.clients.map(client => {
                    return (
                        <InstallerClientCard
                            selected={props.selectedClient._id === client._id}
                            key={client._id} {...client}
                            onEdit={() => {
                                s_new_client(false);
                                s_edit_item(client);
                                s_open_client_dialog(true);
                            }}
                            onClick={() => props.onSelected(client)}
                        />
                    );
                })
            }
            <div>
                <Btn startIcon="user" onClick={() => {
                    s_new_client(true);
                    s_open_client_dialog(true);
                }}>
                    <Tx>g.add</Tx>
                </Btn>
            </div>
            {
                open_client_dialog &&
                <ClientDialog
                    open={open_client_dialog}
                    newClient={new_client}
                    client={edit_item}
                    onClose={() => {
                        s_open_client_dialog(false);
                        s_edit_item({});
                        props.getClients();
                    }}/>
            }
        </StoresColumn>
    );
}
